import { useI18n } from '../../../../hooks/useI18nFormatters';

import { glyph } from '../../../../theme/glyph';
import { theme } from '../../../../theme/theme';
import styles from './DeviceUpdatesPromptDialog.module.css';

import { GradientButton } from '../../../../components/buttons/GradientButton';
import { SolidButton } from '../../../../components/buttons/SolidButton';
import { Glyph } from '../../../../components/common/Glyph';
import { Dialog } from '../../../../components/overlay/Dialog';

interface DeviceUpdatesPromptDialogProps {
  onClose: () => void;
  onStartUpdate: () => void;
  isStartingUpdate?: boolean;
}

export function DeviceUpdatesPromptDialog(props: DeviceUpdatesPromptDialogProps) {
  const { i18n } = useI18n();

  return (
    <Dialog containFocus={true} onClose={props.onClose}>
      <div className={styles.root}>
        <div className={styles.dialogIconWrapper}>
          <div className={styles.dialogIconCircle}>
            <Glyph
              source={glyph.core.clock}
              size={theme.icon.size_xxlarge}
              color={theme.color.blue}
            />
          </div>
        </div>

        <div className={styles.dialogBody}>
          <div className={styles.dialogTitle}>
            {i18n.messageFormatter('settings.system.deviceUpdatesPromptTitle')}
          </div>
          <div className={styles.dialogSubtitle}>
            {i18n.messageFormatter('settings.system.deviceUpdatesPromptSubtitle')}
          </div>
        </div>

        <div className={styles.dialogActions}>
          <SolidButton
            styleColor="default"
            styleFlat={true}
            styleWidth="full"
            onPress={props.onClose}
            isDisabled={props.isStartingUpdate === true}
          >
            <SolidButton.Text>{i18n.messageFormatter('common.cancel')}</SolidButton.Text>
          </SolidButton>

          <GradientButton
            styleColor="blue"
            styleFlat={true}
            styleWidth="full"
            onPress={props.onStartUpdate}
            isDisabled={props.isStartingUpdate === true}
          >
            <GradientButton.Text>
              {i18n.messageFormatter('settings.system.deviceUpdatesPromptStartUpdate')}
            </GradientButton.Text>
          </GradientButton>
        </div>
      </div>
    </Dialog>
  );
}
